export const ADD_BASIC_CONTENT = "ADD_BASIC_CONTENT"
export const ADD_BASIC_CONTENT_SUCCESS = "ADD_BASIC_CONTENT_SUCCESS"
export const ADD_BASIC_CONTENT_FAILED = "ADD_BASIC_CONTENT_FAILED"

export const UPDATE_BASIC_CONTENT = "UPDATE_BASIC_CONTENT"
export const UPDATE_BASIC_CONTENT_SUCCESS = "UPDATE_BASIC_CONTENT_SUCCESS"
export const UPDATE_BASIC_CONTENT_FAILED = "UPDATE_BASIC_CONTENT_FAILED"

export const GET_BASIC_CONTENT = "GET_BASIC_CONTENT"
export const GET_BASIC_CONTENT_SUCCESS = "GET_BASIC_CONTENT_SUCCESS"
export const GET_BASIC_CONTENT_FAILED = "GET_BASIC_CONTENT_FAILED"
export const RESET_BASIC_CONTENT = "RESET_BASIC_CONTENT"

export const GET_BASIC_CONTENT_LIST = "GET_BASIC_CONTENT_LIST"
export const GET_BASIC_CONTENT_LIST_SUCCESS = "GET_BASIC_CONTENT_LIST_SUCCESS"
export const GET_BASIC_CONTENT_LIST_FAILED = "GET_BASIC_CONTENT_LIST_FAILED"
export const RESET_BASIC_CONTENT_LIST = "RESET_BASIC_CONTENT_LIST"
